import { render } from "./RegistroUsuario.vue?vue&type=template&id=4c2f7afa&scoped=true"
import script from "./RegistroUsuario.vue?vue&type=script&lang=js"
export * from "./RegistroUsuario.vue?vue&type=script&lang=js"

import "./RegistroUsuario.vue?vue&type=style&index=0&id=4c2f7afa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c2f7afa"]])

export default __exports__